<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">名称</span>
        <el-input
          v-model="parameter.name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        v-if="tableData.is_admin"
        type="primary"
        icon="el-icon-circle-plus"
        @click="func"
      >创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="投放组id"
        />
        <el-table-column label="组长">
          <template scope="scope">
            <span>{{ scope.row.leader && scope.row.leader.nickname }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="release_group_name"
          label="名称"
        />
        <el-table-column
          prop="feishu_account"
          label="飞书id"
        >
          <template scope="scope">
            <span>{{ scope.row.leader && scope.row.leader.feishu_account }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="feishu_name"
          label="飞书人员"
        >
          <template scope="scope">
            <span>{{ scope.row.leader && scope.row.leader.feishu_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          v-if="tableData.is_admin"
          label="操作"
        >
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="modify(scope.row)"
            >修改</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="(drawer = true),(drawerItem = scope.row)"
            >添加</el-button>
            <el-button
              type="warning"
              size="mini"
              @click="deleteMy(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改投放组' : '创建投放组'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.name = null),(data.id = null), (data.leader_id = null),(app_id = null),(app_ids = null)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">投放组名称</span>
          <el-input
            v-model="data.name"
            class="item_input"
          />
        </div>
        <div class="item">
          <span class="item_title">组长</span>
          <el-select
            v-model="data.leader_id"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in groupLeaders"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="item_title">飞书成员</span>
          <el-autocomplete
            v-model="app_id"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择飞书成员"
            @clear="(app_id = null)"
            @select="handleSelect"
          />
        </div>
      </div>
      <div style="display: flex; margin-top: 30px; justify-content: end;">
        <el-button
          type="primary"
          @click="determine"
        >确定</el-button>
      </div>
    </el-dialog>

    <el-drawer
      ref="drawer"
      title="详情"
      :visible.sync="drawer"
      :with-header="false"
      size="60%"
    >
      <Details
        v-if="drawer"
        :drawer-item="drawerItem"
        @close="$refs.drawer.closeDrawer()"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getReleaseGroupList, addReleaseGroup, updateReleaseGroup, getListOfPitchersInTheLaunchGroup, launchTeamLeader, deleteMy, feishuuserlist } from '@/api/newLaunchGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        name: null
      },
      data: {
        leader_id: null,
        name: null,
        id: null
      },
      dialogVisible: false,
      drawer: false,
      drawerItem: {},
      groupLeaders: [],
      pageinfo: {
        page: 1,
        pageSize: 10
      },
      app_id: null,
      app_ids: null
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getReleaseGroupList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    async modify(row) {
      this.dialogVisible = true
      const data = await getListOfPitchersInTheLaunchGroup({ page: 1, group_id: row.id })
      // console.log('修改', data, row)
      this.groupLeaders = data.data.user
      this.data.name = row.release_group_name
      this.data.leader_id = row.leader && row.leader_id
      this.data.id = row.id
      this.app_id = row.leader.feishu_name
      this.app_ids = row.leader.feishu_account
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.name || !this.data.leader_id) {
        text = '请填写名称'
      }
      // if (this.app_id === null) {
      //   this.$message({
      //     message: '请选择飞书成员',
      //     type: 'error'
      //   })
      //   return
      // }
      // if (this.app_ids === null) {
      //   this.$message({
      //     message: '请选择正确的飞书成员',
      //     type: 'error'
      //   })
      //   return
      // }
      if (!text) {
        const data = {}

        if (this.app_id !== null) {
          data.feishu_name = this.app_id
        }
        if (this.app_ids !== null) {
          data.feishu_account = this.app_ids
        }
        this.data.id ? await updateReleaseGroup({ ...this.data, ...data }) : await addReleaseGroup({ ...this.data, ...data })
      }

      this.$message({
        message: text ? '请填写名称' : this.data.id ? '更新成功' : '创建成功',
        type: text ? 'warning' : 'success'
      })

      if (!text) {
        this.data.name = null
        this.data.leader_id = null
        this.data.id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    async func() {
      this.dialogVisible = true
      const data = await launchTeamLeader()

      this.groupLeaders = data.data.user
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        name: null
      }
      this.getDataList()
    },

    // 删除
    deleteMy(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await deleteMy(row.id)
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    async querySearchAsync(queryString, cb) {
      if (queryString === '') {
        this.app_id = null
        this.app_ids = null
      }
      const data = await feishuuserlist({ ...this.pageinfo, user_name: this.app_id })
      const newArr = data.data.map(item => {
        return { ...item, value: item.name, address: item.openId }
      })
      cb(newArr)
    },
    handleSelect(val) {
      this.app_ids = val.openId
      // console.log(val)
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
